import React from 'react'
import 'flag-icons/css/flag-icons.min.css'

interface FlagIconProps {
  /** ISO 3166-1 alpha-2 country code */
  countryCode: string
  /** Additional CSS classes */
  className?: string
  /** Inline styles */
  style?: React.CSSProperties
}

export const FlagIcon: React.FC<FlagIconProps> = ({ 
  countryCode, 
  className = '', 
  style = {} 
}) => {
  const code = countryCode?.toLowerCase().trim()
  if (!code) {
    return null
  }
  return (
    <span
      className={`inline-block fi fi-${code} ${className}`}
      style={style}
      role="img"
      aria-label={`Flag of ${countryCode}`}
    />
  )
}
